import { InjectionToken } from '@angular/core';
import { IFeatureFlagService } from './feature-flag-service.interface';

export const FEATURE_FLAG_SERVICE = new InjectionToken<IFeatureFlagService>(
    'FEATURE_FLAG_SERVICE'
);
